import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { ApiKeysModuleAccess } from 'app/modules/admin/api-keys/api-keys-module-access/api-keys-module-access';
import { ConfirmDialogComponent } from 'app/modules/admin/common/confirm-dialog/confirm-dialog.component';
import { DocumentationModuleAccess } from 'app/modules/admin/documentation/documentation-module-access/documentation-module-access';
import { HubspotErrorDialogDataFactory } from 'app/modules/admin/issues/hubspot/hubspot-error-dialog-data.factory';
import { IssueModuleAccess } from 'app/modules/admin/issues/module-access/issues-module-access';

export function getDefaultNavigation(
    issueModuleAccess: IssueModuleAccess,
    documentationModuleAccess: DocumentationModuleAccess,
    apiKeysModuleAccess: ApiKeysModuleAccess,
    dialogConfigFactory: HubspotErrorDialogDataFactory,
    confirmDialog: MatDialog,
    http: HttpClient,
    router: Router
): FuseNavigationItem[] {
    return [
        {
            id: 'management',
            title: 'Management',
            type: 'group',
            icon: 'heroicons_outline:home',
            children: [
                {
                    id   : 'overview',
                    title: 'Overview',
                    type : 'basic',
                    icon : 'mat_symbols_outlined:in_home_mode',
                    link : '/overview'
                },
                {
                    id   : 'devices',
                    title: 'Devices',
                    type : 'basic',
                    icon : 'manusa:door_open',
                    link : '/devices'
                },
                {
                    id   : 'users',
                    title: 'Users',
                    type : 'basic',
                    icon : 'heroicons_outline:users',
                    link : '/users'
                },
                {
                    id   : 'keys',
                    title: 'Keys',
                    type : 'basic',
                    icon : 'mat_symbols_outlined:vpn_key',
                    link : '/keys'
                },
                {
                    id   : 'scheduled-actions',
                    title: 'Scheduled actions',
                    type : 'basic',
                    icon : 'heroicons_outline:clock',
                    link : '/scheduled-actions'
                },
                // Hubspot (external) - no link so it never appears as "active"
                {
                    id   : 'issues-hubspot',
                    title: 'My technical support',
                    type : 'basic',
                    icon : 'mat_symbols_outlined:data_info_alert',
                    hidden: () => !issueModuleAccess.canDisplay() || !issueModuleAccess.usesHubspot(),
                    function: () => {
                        http.post('api/issues/hubspot/generate-access', null, { responseType: 'text' }).subscribe({
                            next: (response) => {
                                if (response) {
                                    window.open(response, '_blank');
                                }
                            },
                            error: () => {
                                confirmDialog.open(ConfirmDialogComponent, {
                                    data: dialogConfigFactory.get()
                                });
                            }
                        });
                    },
                },
                // Internal issues - has link so it becomes active only on /issues
                {
                    id   : 'issues',
                    title: 'My technical support',
                    type : 'basic',
                    icon : 'mat_symbols_outlined:data_info_alert',
                    link : '/issues',
                    hidden: () => !issueModuleAccess.canDisplay() || issueModuleAccess.usesHubspot(),
                },
                {
                    id   : 'documentation',
                    title: 'Documentation',
                    type : 'basic',
                    icon : 'mat_outline:attach_file',
                    link : '/documentation',
                    hidden: () => !documentationModuleAccess.isAllowed()
                },
                {
                    id   : 'api-keys',
                    title: 'API Keys',
                    type : 'basic',
                    icon : 'mat_outline:api',
                    link : '/api-keys',
                    hidden: () => !apiKeysModuleAccess.isAllowed()
                },
                {
                    id   : 'device-map',
                    title: 'Device location',
                    type : 'basic',
                    icon : 'mat_symbols_outlined:location_on',
                    link : '/devices-map'
                },
            ]
        },
        {
            id: 'divider-1',
            type: 'divider',
        },
        {
            id: 'reports',
            title: 'Reports',
            type: 'group',
            children: [
                {
                    id   : 'failure-report',
                    title: 'Warnings and errors',
                    type : 'basic',
                    icon : 'mat_outline:article',
                    link : '/reports/failures'
                },
                {
                    id   : 'access-report',
                    title: 'Accesses',
                    type : 'basic',
                    icon : 'mat_symbols_outlined:article_person',
                    link : '/reports/accesses'
                },
            ]
        }
    ];
}

export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
